module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "hatGrad_black.e0947243.png" + "?" + Date.now();